module.exports = __webpack_public_path__ + "assets/retina_SquareInCircleByPtDetailed.a93059cba9620cbd41eb5fd20187fcc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareInCircleByPtDetailed.png
// module id = 721
// module chunks = 0